export default __webpack_public_path__ + "static/media/rightPeople.3eab55e0.png";